"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _presets = require("@zip/theme/dist/presets");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ZipLogo = function ZipLogo(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _presets.fearless : _ref$theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "146",
    height: "56",
    viewBox: "0 0 146 56",
    fill: "none"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      d: "M3.26979 45.673L4.53736 56.0001H48.9136L47.4614 44.1732H26.7712L26.5904 42.7077L45.6476 29.3907L44.3744 19.0427H0L1.45218 30.8695H22.1767L22.3594 32.3483L3.26979 45.673Z",
      fill: theme.colors.secondary
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M49.5303 19.0427L54.0676 56H98.4781L93.9408 19.0427H49.5303Z",
      fill: theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M145.051 32.3484C144.027 24.0407 137.501 19.0065 128.631 19.0427H99.0929L103.628 55.9982H116.917L116.007 48.6078H130.07C141.141 48.6078 146.206 41.7105 145.051 32.3484ZM128.637 38.2484L114.743 38.2637L113.655 29.3945L127.626 29.4059C130.913 29.444 132.594 31.2939 132.864 33.8272C133.032 35.4545 132.286 38.2465 128.637 38.2465V38.2484Z",
      fill: theme.colors.secondary
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M64.1981 14.123C66.5354 11.6139 66.128 7.43528 63.2881 4.7899C60.4482 2.14452 56.2513 2.03409 53.914 4.54327C51.5767 7.05244 51.9841 11.231 54.824 13.8764C57.6639 16.5218 61.8608 16.6322 64.1981 14.123Z",
      fill: theme.colors.black
    })]
  }));
};

var _default = ZipLogo;
exports["default"] = _default;